import CustomButton from "components/CustomButton/CustomButton";
import DialogAlertErrorNotify from "components/DialogAlertNotify/DialogAlertErrorNotify/DialogAlertErrorNotify";
import errorImage1 from "img/error_image_1.svg";
import { ImageNotifyErrorImage } from "views/RefuerzoAcademico/components/AcadReinforceAttendance/styles";

const DialogNotifyNotCheckedOutTime = ({ dialog }) => {
	return (
		<DialogAlertErrorNotify
			show={dialog.value}
			toggleShow={dialog.toggle}
			content={{
				image: (
					<ImageNotifyErrorImage
						src={errorImage1}
						alt="Imagen error en UTP"
					/>
				),
				title: "No puedes marcar tu salida",
				value: "Recuerda que debes tomar la asistencia de los estudiantes antes de marcar tu salida.",
			}}
		>
			<CustomButton
				text="Entendido"
				onClick={() => dialog.set(false)}
			/>
		</DialogAlertErrorNotify>
	);
};

export default DialogNotifyNotCheckedOutTime;
